import { v4 as uuidv4 } from 'uuid';

export default class BaseCollection 
{

    constructor(items, {modelClass})
    {
        this.items = items.map(item => new modelClass(item));
        this.items = this.items.map(item => {
            item.currentCollection = this;
            return item;
        });

        this.modelClass = modelClass;
        this.internal_uuid = uuidv4();
        this.class_name = this.constructor.name;

        this.modelCreatedEventCallback = item => { this.add(item); };
        this.modelUpdatedEventCallback = item => { this.update(item); };
        this.modelDeletedEventCallback = item => { this.remove(item); };

        window.App.$bus.$on(`${this.modelClass.getPrefix()}:created`, this.modelCreatedEventCallback);
        window.App.$bus.$on(`${this.modelClass.getPrefix()}:updated`, this.modelUpdatedEventCallback);
        window.App.$bus.$on(`${this.modelClass.getPrefix()}:deleted`, this.modelDeletedEventCallback);
    }

    isCollection()
    {
        return true;
    }

    destroy()
    {
        for ( let item of this.items ) {
            item.destroy();
        }

        window.App.$bus.$off(`${this.modelClass.getPrefix()}:created`, this.modelCreatedEventCallback);
        window.App.$bus.$off(`${this.modelClass.getPrefix()}:updated`, this.modelUpdatedEventCallback);
        window.App.$bus.$off(`${this.modelClass.getPrefix()}:deleted`, this.modelDeletedEventCallback);
    }

    [Symbol.iterator]() {
        let index = -1;
      
        return {
            next: () => {
                index += 1;
      
                return {
                    value: this.get()[index],
                    done: index >= this.get().length,
                };
            }
        };
    }

    get()
    {
        return this.items.filter(item => this.itemShouldBeInCollection(item));
    }

    itemShouldBeInCollection(item)
    {
        return true;
    }

    add(item)
    {
        if ( this.items.some(i => i.uuid == item.uuid) ) {
            return;
        }
        
        if ( ! this.itemShouldBeInCollection(item) ) {
            return;
        }
        
        this.addItem(item);
    }

    addItem(item)
    {
        item.currentCollection = this;
        this.items.push(item);
        this.onUpdate();
    }

    push(item)
    {
        console.warn('Please use collection.add(item) instead of collection.push(item).');
        this.add(item);
    }

    unshift(item)
    {
        if ( this.items.some(i => i.uuid == item.uuid) ) {
            return;
        }
        
        if ( this.itemShouldBeInCollection(item) ) {
            item.currentCollection = this;
            this.items.unshift(item);
            this.onUpdate();
        }
    }

    update(item)
    {
        if ( this.items.some(i => i.uuid == item.uuid) ) {
            this.onUpdate();
        }
    }

    remove(uuid)
    {
        if ( this.items.some(i => i.uuid == uuid) ) {
            this.items = this.items.filter(item => item.uuid !== uuid);
            this.onUpdate();
        }
    }

    onUpdate()
    {
        return;
    }

    length()
    {
        return this.get().length;
    }

    isEmpty()
    {
        return this.length() === 0;
    }

    isNotEmpty()
    {
        return ! this.isEmpty();
    }

    findIndex(callback)
    {
        return this.get().findIndex(callback);
    }

    map(callback)
    {
        return this.get().map(callback);
    }

    filter(callback)
    {
        return this.get().filter(callback);
    }

    find(callback)
    {
        return this.get().find(callback);
    }

    first(callback)
    {
        return this.get().first(callback);
    }

    some(callback)
    {
        return this.get().some(callback);
    }

    every(callback)
    {
        return this.get().every(callback);
    }

    sort(callback)
    {
        return this.get().sort(callback);
    }

    slice(callback)
    {
        return this.get().slice(callback);
    }

    reduce(callback)
    {
        return this.get().reduce(callback);
    }

}